import { render, staticRenderFns } from "./payroll-fields.component.vue?vue&type=template&id=a73ec9c6&"
import script from "./payroll-fields.component.vue?vue&type=script&lang=js&"
export * from "./payroll-fields.component.vue?vue&type=script&lang=js&"
import style0 from "./payroll-fields.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
